import React from "react";

const JolaCache = props => {
  let { children } = props;
  return <>{children}</>;
};

export default JolaCache;
